export const APP_PRICE_CURRENCY_CODE = "RUB";
export const APP_PRICE_CURRENCY_SYMBOL = "₽";
export function formatAppPrice(value) {
    if (value === null || value === undefined || String(value).trim() === "") {
        return `- ${APP_PRICE_CURRENCY_SYMBOL}`;
    }
    const normalized = String(value).trim().replace(",", ".");
    const num = Number(normalized);
    if (!Number.isFinite(num)) {
        return `${String(value).trim()} ${APP_PRICE_CURRENCY_SYMBOL}`;
    }
    const isInteger = Math.abs(num % 1) < 1e-9;
    const formatted = new Intl.NumberFormat("ru-RU", {
        minimumFractionDigits: isInteger ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(num);
    return `${formatted} ${APP_PRICE_CURRENCY_SYMBOL}`;
}
